import {
  SMALL_TAB_BAR_SIZE,
  MEDIUM_WEB_TAB_BAR_SIZE,
  BIG_WEB_TAB_BAR_SIZE,
} from "./constants";

export const boxVariants = {
  defaults: {},
  screenView: {
    paddingHorizontal: "xm",
    paddingVertical: "xxs",
    flex: 1,
  },
  webOnboarding: {
    alignSelf: "center",
    width: "98vw",
    maxWidth: 1024,
    height: "98vh",
    maxHeight: 770,
    borderRadius: {
      phone: 0,
      web: 20,
    },
    backgroundColor: "neutral.white",
    shadowColor: "shadow",
    shadowOpacity: 0.6,
    shadowOffset: {
      height: 4,
      width: 0,
    },
    shadowRadius: 47,
  },
  webBoxing: {
    flex: 1,
    alignSelf: "center",
    width: "85vw",
    maxWidth: 952,
    maxHeight: 1000,
    alignItems: "center",
  },
  webTabBar: {
    paddingTop: { smallWeb: "xl", web: "webSL" },
    paddingBottom: { smallWeb: "m", web: "webSL" },
    alignItems: "flex-end",
    backgroundColor: "neutral.white",
    width: {
      web: SMALL_TAB_BAR_SIZE,
      webMedium: MEDIUM_WEB_TAB_BAR_SIZE,
      webBig: BIG_WEB_TAB_BAR_SIZE,
    },
    height: "100%",
    position: "fixed",
  },
};
